import { cueFromTextTrackCue } from "./cue";
import type { Cue } from "./cue";

class Timeline {
  readonly #cues: readonly Cue[];

  private constructor(cues: readonly Cue[]) {
    this.#cues = cues;
  }

  get cues(): readonly Cue[] {
    return this.#cues;
  }

  static fromTextTrackCues(raw: TextTrackCue[]): Timeline {
    const cues = raw.map((trackCue, i) => cueFromTextTrackCue(trackCue, `cue_${i}`));
    return new Timeline(cues);
  }
}

export { Timeline };
